<script lang="ts" setup>
    const props = defineProps<{
        title: string,
        isTitleHtml?: string,
        description?: string,
        link?: {
          url: string,
          title: string
        },
        addBackground?: boolean
    }>();

    const parseTitleHtml = props?.isTitleHtml === undefined ? false: props?.isTitleHtml;
</script>
<template>
  <div :class="`headline-wrapper ${addBackground ? 'bg-secondary headline-bg': ''}`">
    <div class="container-fluid">
      <div class="container-xl headline-div">
        <div class="row">
          <div class="col-12 col-lg-4 d-flex flex-column justify-content-between">
            <h1 v-if="!parseTitleHtml" class="title mb-4 text-dark-2">{{ props?.title }}</h1>
            <h1 v-else class="title mb-4 text-dark-2" v-html="props?.title"></h1>
            <div class="w-50 mb-4 d-md-none d-block" style="border-bottom: 1px solid;"></div>
            <a target="_blank" :href="props?.link?.url" :class="`d-none d-md-block btn ${addBackground ? 'btn-white' : 'btn-secondary'} rounded-pill text-uppercase w-50 px-5 py-2`">{{ props?.link?.title }}</a>
          </div>
          <div class="col-12 col-lg-8 description d-flex flex-column justify-content-between" v-html="props?.description">
          </div>
          <div class="d-block d-md-none">
            <a target="_blank" :href="props?.link?.url" :class="`mt-4 btn ${addBackground ? 'btn-white' : 'btn-secondary'} rounded-pill text-uppercase w-50 px-5 py-2`">{{ props?.link?.title }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.headline-wrapper.headline-bg {
  padding: 8rem 0px;
}

.headline-div .row, .headline-div .description {
  min-height: 150px;
}
</style>